import { Check, Download, Terminal } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import type { SkillDetail } from "@/hooks/use-skill";
import { useDownloadSkill } from "@/hooks/use-skill-mutations";
import { copyToClipboard } from "@/lib/clipboard";

export function CtaPanel({ skill }: { skill: SkillDetail }) {
  const download = useDownloadSkill(skill.slug);
  const [copied, setCopied] = useState(false);
  async function copy() {
    const ok = await copyToClipboard(skill.install);
    if (!ok) {
      toast.error("Couldn't copy — select the command and copy it manually");
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }
  return (
    <div className="rounded-[12px] bg-navy p-5 text-white">
      <div className="font-display text-3xl font-bold">{skill.downloads.toLocaleString()}</div>
      <div className="text-sm text-white/60">downloads · v{skill.version}</div>
      <Button
        variant="gradient"
        className="mt-4 w-full justify-center"
        disabled={download.isPending}
        onClick={() => download.mutate()}
      >
        <Download className="size-4" />
        Download skill
      </Button>
      <button
        type="button"
        onClick={() => void copy()}
        className="mt-2.5 flex w-full items-center justify-center gap-2 rounded-[9px] bg-white/10 px-3 py-2.5 text-sm font-medium text-white hover:bg-white/20"
      >
        {copied ? <Check className="size-4" /> : <Terminal className="size-4" />}
        {copied ? "Command copied" : "Copy install command"}
      </button>
    </div>
  );
}
